
import {useTranslation} from "react-i18next";
import React from "react";
import {useAdmin} from "../../../contexts/AdminContext";
import Card from "../../../components/Card";
import {useGlobalContext} from "../../../contexts/globalContext";
import cx from "classnames";
import styles from "./SubscriptionOverview.module.css";
import CurrentSubscription from "../CurrentSubscription";

const SubscriptionOverview: React.FC<{changePage: (p: string) => void}> = ({changePage}) => {
    const { getSubscription, subscription } = useAdmin()
    const { t } = useTranslation(['settings'])
    const { showToast } = useGlobalContext()

    return (
        <>
            <div  className={cx(styles['container'], 'my-6')}>
                {subscription &&
                    <Card title={t("subscription.currentSubscription")} actions={[
                        {
                            title: t("subscription.syncWithServer"),
                            type: 'secondary',
                            onAction: () => {
                                getSubscription()
                                showToast('top-right', 'success', t("subscription.syncSuccess"))
                            },
                            classes: 'm-3 w-100'
                        }]}
                    >
                        <CurrentSubscription/>
                    </Card>
                }
                <Card
                    title={t('subscription.alreadyACustomer')}
                    actions={[
                        {
                            title: t('subscription.login'),
                            type: 'primary',
                            onAction: () => changePage('login'),
                            classes: 'm-3 w-100'
                        }]}
                >
                    <div className={'pb-3'}>
                        <p>
                            {t('subscription.alreadyACustomerText')}
                        </p>
                    </div>
                </Card>
                <Card
                    title={t('subscription.newCustomer')}
                    actions={[
                        {
                            title: t('subscription.registerNow'),
                            type: 'primary',
                            onAction: () => changePage('register'),
                            classes: 'm-3 w-100'
                        }]}
                >
                    <div className={'pb-3'}>
                        {t('subscription.newCustomerText')}
                    </div>
                </Card>
            </div>
        </>
    )
}

export default SubscriptionOverview
